import React from 'react';
import { useNavigate } from 'react-router';
import './YouHaveThisPill.css';

interface YouHaveThisPillProps {
  actorUsername: string;
  ownedCount: number;
  totalInEvent: number;
}

const buildLabel = (ownedCount: number, totalInEvent: number): string => {
  if (totalInEvent === 1) return 'Send now →';
  if (ownedCount === 1) return 'Send 1 →';
  if (ownedCount === totalInEvent) return 'Send all of these →';
  return `Send ${ownedCount} of these →`;
};

export const YouHaveThisPill: React.FC<YouHaveThisPillProps> = ({
  actorUsername,
  ownedCount,
  totalInEvent,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    const params = new URLSearchParams({
      searchType: 'user',
      search: actorUsername,
    });
    navigate(`/sendcards?${params.toString()}`);
  };

  return (
    <button
      type="button"
      className="feed-send-now-pill"
      onClick={handleClick}
    >
      {buildLabel(ownedCount, totalInEvent)}
    </button>
  );
};

export default YouHaveThisPill;
